var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAsanaWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "asana-white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sprint",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Importing-from-Asana",
    transform: "translate(-582.000000, -12.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(582.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "asana-white",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6044177,8.39265062 C11.5114304,8.39265062 9.82191046,10.0587472 9.82191046,12.1227176 C9.82191046,14.1866879 11.5114304,15.8527845 13.6044177,15.8527845 C15.697405,15.8527845 17.3869249,14.1866879 17.3869249,12.1227176 C17.3869249,10.0711807 15.697405,8.39265062 13.6044177,8.39265062 Z M3.78250724,8.39265062 C1.6895199,8.39265062 1.12712379e-12,10.0587472 1.12712379e-12,12.1227176 C1.12712379e-12,14.1866879 1.6895199,15.8527845 3.78250724,15.8527845 C5.87549458,15.8527845 7.56501448,14.1866879 7.56501448,12.1227176 C7.56501448,10.0711807 5.86288622,8.39265062 3.78250724,8.39265062 Z M12.4822739,3.73006694 C12.4822739,5.79403732 10.792754,7.46013388 8.69976665,7.46013388 C6.60677931,7.46013388 4.91725941,5.79403732 4.91725941,3.73006694 C4.91725941,1.66609657 6.60677931,-4.87229305e-15 8.69976665,-4.87229305e-15 C10.7801456,-4.87229305e-15 12.4822739,1.66609657 12.4822739,3.73006694 Z",
    id: "Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsanaWhite);
export default __webpack_public_path__ + "static/media/asana-white.0e1506d0.svg";
export { ForwardRef as ReactComponent };